import ninjaApi from 'store/redux/apis';

export const reportApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: [],
  endpoints: (builder) => ({
    getReportInfo: builder.mutation({
      query: (body) => ({
        url: '/reporting/get-info',
        method: 'POST',
        body,
      }),
    }),

    trafficReportingOverview: builder.query({
      query: (body) => ({
        url: '/reporting/traffic-reporting/overview',
        method: 'POST',
        body,
      }),
    }),

    eventsOverview: builder.query({
      query: (body) => ({
        url: 'reporting/traffic-reporting/events-overview',
        method: 'POST',
        body,
      }),
    }),

    trafficByperiod: builder.query({
      query: (body) => ({
        url: 'reporting/traffic-reporting/traffic-by-period',
        method: 'POST',
        body,
      }),
    }),

    frequentPages: builder.query({
      query: (body) => ({
        url: 'reporting/traffic-reporting/frequent-pages',
        method: 'POST',
        body,
      }),
    }),

    trafficReportingEvents: builder.query({
      query: (body) => ({
        url: 'reporting/traffic-reporting/events',
        method: 'POST',
        body,
      }),
    }),

    trafficReportingRecent: builder.query({
      query: (body) => ({
        url: 'reporting/traffic-reporting/recent',
        method: 'POST',
        body,
      }),
    }),

    userJourney: builder.mutation({
      query: (body) => ({
        url: '/reporting/collect/user-journey',
        method: 'POST',
        body,
      }),
    }),

    getEventDetails: builder.query({
      query: (body) => ({
        url: '/reporting/traffic-reporting/get-event',
        method: 'POST',
        body,
      }),
    }),

    getReportUser: builder.query({
      query: (body) => ({
        url: '/reporting/traffic-reporting/get-user',
        method: 'POST',
        body,
      }),
    }),

    getReferrers: builder.query({
      query: (body) => ({
        url: '/reporting/traffic-reporting/referrers',
        method: 'POST',
        body,
      }),
    }),

    getSources: builder.query({
      query: (body) => ({
        url: '/reporting/traffic-reporting/sources',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetReportInfoMutation,
  useTrafficReportingOverviewQuery,
  useEventsOverviewQuery,
  useTrafficByperiodQuery,
  useUserJourneyMutation,
  useFrequentPagesQuery,
  useTrafficReportingEventsQuery,
  useTrafficReportingRecentQuery,
  useGetReportUserQuery,
  useGetEventDetailsQuery,
  useGetReferrersQuery,
  useGetSourcesQuery,
} = ninjaApi;
